<!-- Ported from the Polaris kit: src/components/ui/attachment/AttachmentContent.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <div
    data-slot="attachment-content"
    :class="
      cn(
        'leading-tight group-data-[orientation=vertical]/attachment:px-1 max-w-full min-w-0 flex-1',
        props.class
      )
    "
    v-bind="props"
  >
    <slot />
  </div>
</template>
